export const OPTION_TYPES = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
};

export const BADGE_VARIANT = "save";

export const getBadgeText = (type, translate) => {
  return type === OPTION_TYPES.ANNUAL ? translate("annual-save") : null;
};

const helper = {
  OPTION_TYPES,
  BADGE_VARIANT,
  getBadgeText,
};

export default helper;
